module.exports = "https://static.cdns.space/tarot-temp/img/m_banner.5ef7c621.png";